<template>
    <card minify="true">
        <card-header>
            <card-overline>
                <translate>Details zur Ausschreibung</translate>
            </card-overline>
        </card-header>
        <card-content>
            <description-group grid="true">
                <description-element :caption="askForQuote.bid_rounds_count"
                                     :title="this.$gettext('Ausschreibungen')"/>
                <description-element :caption="askForQuote.bid_round_members_count"
                                     :title="this.$gettext('verschickte Anfragen')"/>
                <description-element :caption="askForQuote.bid_round_member_offers_count"
                                     :title="this.$gettext('erhaltene Angebote')"/>
            </description-group>
        </card-content>
    </card>
</template>

<script>
import Card from '@partfactory/Shared/Card/Card';
import CardHeader from '@partfactory/Shared/Card/CardHeader';
import CardOverline from '@partfactory/Shared/Card/CardOverline';
import CardContent from '@partfactory/Shared/Card/CardContent';
import DescriptionElement from '@partfactory/Shared/Elements/DescriptionElement';
import DescriptionGroup from '@partfactory/Shared/Elements/DescriptionGroup';

export default {
    name: 'ComponentSidebarProposals',
    components: {DescriptionGroup, DescriptionElement, CardContent, CardOverline, CardHeader, Card},
    props: {
        askForQuote: Object,
    },
};
</script>
